import { Button } from '@app/app/_components/Button/Button';
import { ArrowRightIcon } from '@app/app/_icons/ArrowRightIcon';
import { SaveProgressModal } from '@app/app/esales/life/_sections/steps/SaveProgressModal';
import { FormState } from '@app/lib/form/contracts/FormState';
import { PurchaseLifeInsuranceResult } from '@app/service/eshop/life/actions/purchaseLifeInsurance';
import { LIFE_INSURANCE_STEPS } from '@app/app/esales/life/_sections/steps/LIFE_INSURANCE_STEPS';
import { useTranslations } from 'next-intl';

interface Props {
    currentStepKey: string;
    formState: FormState<PurchaseLifeInsuranceResult>;
    isModalOpen: boolean;
    closeModal: () => void;
    handleSuccess: () => void;
    openModal: () => void;
}

export function FirstStepSaveFooter({
    currentStepKey,
    formState,
    isModalOpen,
    closeModal,
    handleSuccess,
    openModal,
}: Props) {
    const t = useTranslations();

    if (!formState.data?.formData || !formState.data?.packages) {
        return null;
    }

    return (
        <>
            <SaveProgressModal
                open={isModalOpen}
                onClose={closeModal}
                onSuccess={handleSuccess}
                data={formState.data.formData}
                packages={formState.data.packages}
            />

            <div className="flex w-full flex-col-reverse gap-4 sm:flex-row">
                <Button
                    preventDefault
                    className="w-full"
                    variant="outlined"
                    onClick={openModal}
                    rightAddon={<ArrowRightIcon className="size-4" />}>
                    {t('eshop.life.saveAndContinueLater')}
                </Button>
                <Button className="w-full" rightAddon={<ArrowRightIcon className="size-4" />}>
                    {currentStepKey === LIFE_INSURANCE_STEPS.PACKAGES_DONE
                        ? t('eshop.life.nextLifestyleAndHealth')
                        : t('auth.login')}
                </Button>
            </div>
        </>
    );
}
